import { Link } from 'react-router-dom'
import { GENERATE_CLOSEOUT_CONFIRM } from './pulseCloseoutChecks.js'
import { PulseAddFilesButton } from './PulseAddFiles.tsx'
import PulseDownloadAll from './PulseDownloadAll'
import PulseIcon from './PulseIcon'
import type { Project } from '../../api/types'
import type { PayApp } from '../../api/types'
import PayAppCta from '../../components/billing/PayAppCta'
import ArOpenButton from '../../components/billing/ArOpenButton'

export default function PulseStickyHeader({
  projectId,
  projectNumber,
  projectName,
  owner,
  tab,
  onTab,
  onWhatChanged,
  onFilesUploaded,
  onOpenAr,
  project,
  payApps = [],
}: {
  projectId: number
  projectNumber?: string | null
  projectName?: string | null
  owner?: string | null
  project?: Project | null
  payApps?: PayApp[]
  tab: 'pulse' | 'closeout'
  onTab: (next: 'pulse' | 'closeout') => void
  onWhatChanged: () => void
  onFilesUploaded?: () => void
  onOpenAr?: () => void
}) {
  return (
    <header className="pulse-sticky" data-testid="pulse-sticky">
      <div className="pulse-crumb">
        <Link to="/projects">Projects</Link>
        {projectNumber ? ` / #${projectNumber}` : ''}
      </div>
      <div className="pulse-title-row">
        <span className="pulse-emblem" aria-hidden="true">
          <PulseIcon size={22} />
        </span>
        <h1 className="pulse-title">{projectName || 'Pulse'}</h1>
      </div>
      <p className="pulse-sub">{owner ? String(owner) : 'Current project snapshot'}</p>
      <div className="pulse-header-actions" data-testid="pulse-header-actions">
        {onOpenAr ? (
          <ArOpenButton project={project} testId="pulse-ar-open-btn" onClick={onOpenAr} />
        ) : null}
        <PayAppCta
          projectId={projectId}
          project={project}
          payApps={payApps}
          testId="pulse-new-payapp-btn"
        />
      </div>
      <div className="pulse-actions">
        <PulseAddFilesButton projectId={projectId} onUploaded={onFilesUploaded} />
        <PulseDownloadAll projectId={projectId} testId="pulse-download-all" />
        <button type="button" className="btn b-dk btn-sm" data-testid="pulse-what-changed" onClick={onWhatChanged}>
          What changed
        </button>
        <span className="pulse-disabled-tip" title={GENERATE_CLOSEOUT_CONFIRM}>
          <button type="button" className="btn b-ol btn-sm" data-testid="pulse-generate-closeout" data-confirm={GENERATE_CLOSEOUT_CONFIRM} disabled>
            Generate closeout
          </button>
        </span>
      </div>
      <div className="pulse-tabs" role="tablist">
        <button type="button" role="tab" aria-selected={tab === 'pulse'} className="pulse-tab" data-testid="pulse-tab-pulse" onClick={() => onTab('pulse')}>Pulse</button>
        <button type="button" role="tab" aria-selected={tab === 'closeout'} className="pulse-tab" data-testid="pulse-tab-closeout" onClick={() => onTab('closeout')}>Closeout</button>
      </div>
    </header>
  )
}
